import type { ElementType } from 'react';
import { useEffect, useState } from 'react';
import { useAuth } from '@eti/authentication';
import { useLoadingState } from '../../custom-hooks/useLoadingState';
import LoadingAnimation from '../../loading/components/LoadingAnimation';
import ErrorPage from '../../../pages/status-pages/components/ErrorPage';
import Route from './Route';

interface VerifyUserRouteProps {
  component: ElementType;
  dataLayerPathname?: string;
  exact?: boolean;
  path: string | string[];
  props: any;
  redirectTo?: string;
}

const VerifyUserRoute = ({
  component: Component,
  dataLayerPathname,
  exact,
  path,
  props,
  redirectTo,
}: VerifyUserRouteProps) => {
  const { verifyUser } = useAuth();
  const [isAuthenticationFinished, setIsAuthenticationFinished] = useState<boolean | null>(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await verifyUser();
        setIsAuthenticationFinished(Boolean(data));
      } catch {
        setIsAuthenticationFinished(false);
      }
    })();
  }, [verifyUser]);

  const shouldShowLoading = useLoadingState(isAuthenticationFinished === null);

  if (isAuthenticationFinished === false) {
    return <ErrorPage />;
  }

  if (shouldShowLoading) {
    return <LoadingAnimation />;
  }

  return (
    <Route
      component={Component}
      dataLayerPathname={dataLayerPathname}
      exact={exact}
      path={path}
      props={props}
      redirectTo={redirectTo}
    />
  );
};

export default VerifyUserRoute;
